import Vue from 'vue';

import { initialState } from './state';
import StoreModuleService from '../StoreModuleService';
import BillingService from '@/components/Billing/billing-service';
import { camelize } from '@/utils/helpers';

// mutations declarations
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_ENTITLEMENTS = 'SET_ENTITLEMENTS';
export const SET_CUSTOMER_DATA = 'SET_CUSTOMER_DATA';
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
export const SET_PRICING_PREVIEW = 'SET_PRICING_PREVIEW';
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS';
export const SET_IS_ANNUALLY_PLAN = 'SET_IS_ANNUALLY_PLAN';
export const DELETE_PAYMENT_METHOD = 'DELETE_PAYMENT_METHOD';
export const SET_ENTITLEMENT_PLANS = 'SET_ENTITLEMENT_PLANS';
export const SET_SUBSCRIPTION_HISTORY = 'SET_SUBSCRIPTION_HISTORY';
export const SET_FEATURE_USAGE_HISTORY = 'SET_FEATURE_USAGE_HISTORY';
export const SET_ORGANIZATION_SETTINGS = 'SET_ORGANIZATION_SETTINGS';
export const SET_FEATURE_USAGE_ANALYTICS = 'SET_FEATURE_USAGE_ANALYTICS';
export const SET_ENTITLEMENTS_LAST_REFRESH = 'SET_ENTITLEMENTS_LAST_REFRESH';
export const SET_PRODUCT_AUTOMATED_CHANGES = 'SET_PRODUCT_AUTOMATED_CHANGES';
export const SET_DEFAULT_PAYMENT_METHOD_ID = 'SET_DEFAULT_PAYMENT_METHOD_ID';
export const SET_ENTITLEMENTS_IS_REFRESHING = 'SET_ENTITLEMENTS_IS_REFRESHING';
export const SET_OVERAGES_ESTIMATED_COST = 'SET_OVERAGES_ESTIMATED_COST';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_PRODUCTS](state, products) {
		Vue.set(state, 'products', products);
	},
	[SET_ORGANIZATION_SETTINGS](state, organizationSettings) {
		Vue.set(state, 'organizationSettings', organizationSettings);
	},
	[SET_SUBSCRIPTIONS](state, subscriptions) {
		const camelizedSubscriptions = camelize(subscriptions);
		Vue.set(state, 'subscriptions', camelizedSubscriptions);
		Vue.set(state, 'isAnnuallyPlan', BillingService.isAnnuallySubscription(camelizedSubscriptions));
	},
	[SET_IS_ANNUALLY_PLAN](state, isAnnuallyPlan) {
		Vue.set(state, 'isAnnuallyPlan', isAnnuallyPlan);
	},
	[SET_PRICING_PREVIEW](state, pricingPreview) {
		Vue.set(state, 'pricingPreview', pricingPreview);
	},
	[SET_CUSTOMER_DATA](state, customerData) {
		Vue.set(state, 'customerData', customerData);
	},
	[SET_ENTITLEMENTS](state, entitlements) {
		Vue.set(state, 'entitlements', entitlements);
	},
	[SET_ENTITLEMENTS_LAST_REFRESH](state, sync_date) {
		Vue.set(state, 'entitlementsLastRefresh', sync_date);
	},
	[SET_ENTITLEMENTS_IS_REFRESHING](state, isRefreshing) {
		Vue.set(state, 'entitlementsIsRefreshing', isRefreshing);
	},
	[SET_PAYMENT_METHODS](state, paymentMethods) {
		Vue.set(state, 'paymentMethods', paymentMethods);
	},
	[SET_DEFAULT_PAYMENT_METHOD_ID](state, paymentMethodId) {
		Vue.set(state, 'defaultPaymentMethodId', paymentMethodId);
	},
	[DELETE_PAYMENT_METHOD](state, paymentMethodId) {
		Vue.delete(state.paymentMethods, paymentMethodId);
	},
	[SET_ENTITLEMENT_PLANS](state, entitlementPlans) {
		Vue.set(state, 'entitlementPlans', entitlementPlans);
	},
	[SET_FEATURE_USAGE_HISTORY](state, { featureId, featureUsageHistory }) {
		Vue.set(state.usageHistory, featureId, featureUsageHistory);
	},
	[SET_FEATURE_USAGE_ANALYTICS](state, { featureId, featureUsageAnalytics }) {
		Vue.set(state.usageAnalytics, featureId, featureUsageAnalytics);
	},
	[SET_SUBSCRIPTION_HISTORY](state, { productId, subscriptionHistory }) {
		Vue.set(state.subscriptionHistory, productId, subscriptionHistory);
	},
	[SET_PRODUCT_AUTOMATED_CHANGES](state, { productId, productAutomatedSubscriptionChanges }) {
		Vue.set(state.productAutomatedSubscriptionChanges, productId, productAutomatedSubscriptionChanges);
	},
	[SET_OVERAGES_ESTIMATED_COST](state, { estimatedCosts }) {
		Vue.set(state, 'overagesEstimatedCost', estimatedCosts);
	},
};

export default mutations;
